export interface IDateHelperService {
    convertDatesToNumbers: (objectToConvert: any) => any,
    convertNumbersToDates: (objectToConvert: any) => any,
    formatDuration: (miliseconds: number) => string,
}

const DateHelperService: IDateHelperService = {

    convertDatesToNumbers: (objectToConvert: any) => { 
        if(objectToConvert) {
            const convertedObject = {...objectToConvert};

            if(convertedObject.createdDate) { convertedObject.createdDate = convertedObject.createdDate.getTime() };
            if(convertedObject.modifiedDate) { convertedObject.modifiedDate = convertedObject.modifiedDate.getTime() };
            if(convertedObject.notActiveDate) { convertedObject.notActiveDate = convertedObject.notActiveDate.getTime() };
            if(convertedObject.dateDisplayed) { convertedObject.dateDisplayed = convertedObject.dateDisplayed.getTime() };
            if(convertedObject.startDate) { convertedObject.startDate = convertedObject.startDate.getTime() };
            if(convertedObject.sortDate) { convertedObject.sortDate = convertedObject.sortDate.getTime() };

            return convertedObject;
        }
        return undefined;
    },

    convertNumbersToDates: (objectToConvert: any) => { 
        if(objectToConvert) {
            const convertedObject = {...objectToConvert};

            if(convertedObject.createdDate) { convertedObject.createdDate = new Date(convertedObject.createdDate) };
            if(convertedObject.modifiedDate) { convertedObject.modifiedDate = new Date(convertedObject.modifiedDate) };
            if(convertedObject.notActiveDate) { convertedObject.notActiveDate = new Date(convertedObject.notActiveDate) };
            if(convertedObject.dateDisplayed) { convertedObject.dateDisplayed = new Date(convertedObject.dateDisplayed) };
            if(convertedObject.startDate) { convertedObject.startDate = new Date(convertedObject.startDate) };
            if(convertedObject.sortDate) { convertedObject.sortDate = new Date(convertedObject.sortDate) };
    
            return convertedObject;
        }
        return undefined;
    },

    formatDuration: (milliseconds) => {
        let seconds = Math.floor(milliseconds / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);

        seconds = seconds % 60;
        minutes = minutes % 60;

        const hoursString = hours ? `${hours.toString()}:` : '';
        const minutesString = minutes ? `${minutes.toString().padStart(2, '0')}:` : '';
        const secondsString = !hours && !minutes ? 
            seconds.toString() + ' Seconds' : seconds.toString().padStart(2, '0');

        return hoursString + minutesString + secondsString;
    }
}

export default DateHelperService;